import { useMemo } from "react";
import type { Dictionary, SortingOptions } from "types";

type Props = {
  dictionary: Dictionary;
};

export default function useSortingOptions({ dictionary }: Props) {
  return useMemo<SortingOptions>(() => {
    return Object.entries(dictionary)
      .filter(([key]) => key.startsWith("sort_"))
      .map(([key, label]) => ({
        id: key.slice(5),
        label,
      })) as SortingOptions;
  }, [dictionary]);
}
